import { TickIcon, TickIconGlyph } from '../elements/tick-icon';
export var BenefitIcon = TickIcon;
export var BenefitIconGlyph = TickIconGlyph;